import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { I18nModule, UrlModule } from '@spartacus/core'
import { IconModule } from '@spartacus/storefront'
import { EbDocumentLinkComponent } from './eb-document-link.component'

@NgModule({
  declarations: [EbDocumentLinkComponent],
  exports: [EbDocumentLinkComponent],
  imports: [I18nModule, IconModule, UrlModule, NgbTooltipModule, CommonModule]
})
export class EbDocumentLinkModule {}
